import { render } from "./CommunitySettings.vue?vue&type=template&id=1eb25b40&scoped=true"
import script from "./CommunitySettings.vue?vue&type=script&lang=js"
export * from "./CommunitySettings.vue?vue&type=script&lang=js"

import "./CommunitySettings.vue?vue&type=style&index=0&id=1eb25b40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb25b40"]])

export default __exports__